import React from 'react'
import {getColor} from 'startlibs/lib/lib'
import styled, {css} from 'styled-components'

export const ToggleContainer = styled.div `
  background-color: rgba(0,0,0,0.06);
  border-radius: 6px;
  padding: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  :hover {
    background-color: rgba(0,0,0,0.075);
  }
  :active {
    background-color: rgba(0,0,0,0.1);
  }
  .help-text {
    font-weight: 400;
    color: ${getColor('gray120')};
    font-size: 12px;
  }
`

export const Toggle = styled.div `
  width: 2.75rem;
  height: 18px;
  border-radius: 18px;
  background: ${props => props.checked ? getColor('main') : 'rgba(0,0,0,0.2)'};
  display: inline-block;
  position: relative;
  cursor: pointer;
  transition: 0.25s ease;
  :after {
    content: '';
    transition: 0.25s ease;
    transition: none;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: white;
    ${props => props.checked ? css`
      left: 100%;
      margin-left: -2px;
      transform: translate(-100%,-50%);
      ` : `
      left: 0;
      margin-left: 2px;
    `}
  }
`


// WEBPACK FOOTER //
// ./~/report-components/src/components/Toggle.jsx